import * as types from '../types'

// key: "tasks" for the standalone Task agenda page.
// filters: { status?, assigned_to? }
export const getTaskList = (key, filters = {}, loadMoreData = false) => (
  { type: types.TASK_ACTION_GET_TASK_LIST, key, filters, loadMoreData }
)

export const refreshTaskLists = () => ({ type: types.TASK_ACTION_REFRESH_LISTS })

export const getTask = (taskKey) => ({ type: types.TASK_ACTION_GET_TASK, taskKey })

export const createTask = (data, completeCallback) => (
  { type: types.TASK_ACTION_CREATE_TASK, data, completeCallback }
)

export const deleteTask = (taskKey, completeCallback) => (
  { type: types.TASK_ACTION_DELETE_TASK, taskKey, completeCallback }
)

export const updateTask = (taskKey, data, completeCallback) => (
  { type: types.TASK_ACTION_UPDATE_TASK, taskKey, data, completeCallback }
)
